import { render } from "./Topics.vue?vue&type=template&id=f625c1c8"
import script from "./Topics.vue?vue&type=script&lang=ts"
export * from "./Topics.vue?vue&type=script&lang=ts"

import "./Topics.vue?vue&type=style&index=0&id=f625c1c8&lang=scss"
script.render = render

export default script